import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CustomDropdownComponent } from '../custom-dropdown/custom-dropdown.component';
import { DropdownOptionComponent } from '../custom-dropdown/dropdown-option.component';
import { CustomInputComponent } from '../custom-input/custom-input.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ScrollingModule,
    CustomDropdownComponent,
    DropdownOptionComponent,
    CustomInputComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ScrollingModule,
    CustomDropdownComponent,
    DropdownOptionComponent,
    CustomInputComponent,
  ],
})
export class SharedModule {}
